import {ThemeColorName, ThemeSpacingName} from '../../theme/types';
import {EditorState} from './types';

type EditorStyleMapType = {
  [key in EditorState]: {
    textColor: ThemeColorName;
    enhancerColor: ThemeColorName;
    placeholderColor: ThemeColorName;
    selectionColor: ThemeColorName;
    selectionBackgroundColor: ThemeColorName;
    backgroundColor: ThemeColorName;
    borderFocusColor: ThemeColorName | undefined;
    iconReversed: boolean;
    padding: {
      paddingHorizontal: ThemeSpacingName;
      paddingVertical: ThemeSpacingName;
    };
  };
};

export const EditorStyleMap: EditorStyleMapType = {
  Default: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_mono_tertiary',
    borderFocusColor: 'border_accent_default',
    iconReversed: true,
    padding: {paddingHorizontal: '14', paddingVertical: '14'},
  },
  Success: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_positive_light',
    borderFocusColor: 'border_positive_default',
    iconReversed: true,
    padding: {paddingHorizontal: '14', paddingVertical: '14'},
  },
  Error: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_negative_light',
    borderFocusColor: 'border_negative_default',
    iconReversed: true,
    padding: {paddingHorizontal: '14', paddingVertical: '14'},
  },
  Disabled: {
    textColor: 'content_mono_disabled',
    placeholderColor: 'content_mono_disabled',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_disabled',
    backgroundColor: 'background_mono_tertiary',
    borderFocusColor: 'transparent',
    iconReversed: true,
    padding: {paddingHorizontal: '14', paddingVertical: '14'},
  },
};
